// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Je9p","colBig":"styles_colBig__2teIg","colSmall":"styles_colSmall__3zarX","shopifyNameWrapper":"styles_shopifyNameWrapper__16hm8"};